import { mergeSx } from "@/common/utils/mergeSx";
import { Container, Paper } from "@mui/material";

export const LoginContainer = ({ sx, children, ...restProps }) => {
  const defaultSx = {
    padding: 4,
    marginTop: 10,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    maxWidth: "400px",
  };
  const finalSx = mergeSx(defaultSx, sx);
  return (
    <Container sx={finalSx} maxWidth="sx" component={Paper} {...restProps}>
      {children}
    </Container>
  );
};
